export function navigateToVerseOfDayScreen() {}

export async function handleVerseOfDayNotificationOpen() {}

export function subscribeVerseOfDayNotificationPress() {
  return () => {};
}
